import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { getActiveTreeStore } from "./uploadNotification.js";
import { ProBox } from "../components/tree/proFooter.js";
import { isHiddenFile } from "../utils/path.js";
import { rmlOpts } from "../utils/rmlOpts.js";
function getActiveRmlFolderFromBrowser(backboneView) {
    const toolbar = backboneView?.toolbar;
    if (!toolbar?.get) {
        return undefined;
    }
    const filter = toolbar.get("rml_folder");
    const folderId = filter?.model?.get("rml_folder");
    return typeof folderId === "string" || typeof folderId === "number" ? folderId : undefined;
}
function getNodeId() {
    const selectVal = $(".attachments-filter-preUploadUi:visible:first").prev();
    const id = +selectVal.val();
    if (id) {
        const fromFilter = selectVal.data("node");
        if (fromFilter) {
            return fromFilter;
        }
    }
    const activeStore = getActiveTreeStore();
    const fromLastQueried = activeStore.getTreeItemById(rmlOpts.others.lastQueried, false);
    if (fromLastQueried) {
        return fromLastQueried;
    }
    if (activeStore.selected) {
        return activeStore.selected;
    }
    return activeStore.getTreeItemById(activeStore.selectedId, false);
}
function createRecursiveUploadProBox() {
    const proBoxElementId = "pro-box-recursive-upload";
    if (!document.getElementById(proBoxElementId)) {
        const proBoxElement = document.createElement("div");
        proBoxElement.id = proBoxElementId;
        document.body.append(proBoxElement);
        const root = createRoot(proBoxElement);
        root.render(/*#__PURE__*/ _jsx(ProBox, {
            feature: "recursive-upload",
            onClose: ()=>root.unmount()
        }));
    }
}
function fixAddFileToSkipHiddenFiles(uploader) {
    const target = uploader;
    const oldAddFile = target.addFile;
    target.addFile = (function(file, ...rest) {
        const files = (Array.isArray(file) ? file : [
            file
        ]).filter((f)=>{
            const source = f.getSource();
            if (source && isHiddenFile(f.name)) {
                return false;
            }
            return true;
        });
        oldAddFile.apply(target, [
            files,
            ...rest
        ]);
    }).bind(target);
}
export { createRecursiveUploadProBox, fixAddFileToSkipHiddenFiles, getActiveRmlFolderFromBrowser, getNodeId };
